import { Box, CircularProgress, Tooltip, useTheme } from "@mui/material"
import dayjs from "dayjs"
import { ScheduleEventMeetingItemDto } from "./SchedulePage"
import { eventStatusCodes, eventStatusDesc } from "../../shared/commonConstants"
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';

interface ScheduleEventItemProps {
    eventMeeting: ScheduleEventMeetingItemDto
}

export const ScheduleEventItem = ({
    eventMeeting
}: ScheduleEventItemProps) => {

    const theme = useTheme();

    const warningStatuses = [eventStatusCodes.Void, eventStatusCodes.Abandon];
    const showWarning = warningStatuses.includes(eventMeeting?.eventStatus ?? '');

    const warningMessage = `Event has been ${eventStatusDesc(eventMeeting?.eventStatus ?? '')}`;

    return (
        <>
            {eventMeeting.id === -1 &&
                <>
                    <CircularProgress size={24} sx={{ marginRight: 1 }} />
                    Loading
                </>
            }
            {eventMeeting.id !== -1 &&
                <>
                    {showWarning &&
                        <Tooltip title={warningMessage} arrow placement="top">
                            <Box sx={{ position: 'absolute', margin: '2px 0 0 -20px' }}>
                                <DoNotDisturbAltIcon sx={{ fontSize: "14px", color: theme.palette.error.dark }} />
                            </Box>
                        </Tooltip>
                    }
                    <span style={{ fontSize: '14px' }}>
                        {`${dayjs(eventMeeting.dateTime).format("HH:mm")} -  Race ${eventMeeting.number} - ${eventMeeting.name}`}
                    </span>
                </>
            }
        </>
    )
}
